import SalesHistoryManager from './SalesHistoryManager'

export default SalesHistoryManager
